"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var _default = exports.default = {
  getProductList: function getProductList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProduct/page',
      method: 'get',
      params: params
    });
  },
  getOrdeList: function getOrdeList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProductOrder/page',
      method: 'get',
      params: params
    });
  },
  exportOrderList: function exportOrderList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProductOrder/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  getCouponList: function getCouponList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProductOrderDetail/page',
      method: 'get',
      params: params
    });
  },
  exportCouponList: function exportCouponList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProductOrderDetail/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  updateCouponLogNo: function updateCouponLogNo(data) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProductOrderDetail/updateCouponNo',
      method: 'post',
      data: data
    });
  },
  addProduct: function addProduct(data) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProduct/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  getDetail: function getDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProduct/' + id,
      method: 'get'
    });
  },
  changeActStatus: function changeActStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProduct/updateStatus',
      method: 'post',
      data: data
    });
  },
  // 根据券第三方id获取,
  getCouponByThirdId: function getCouponByThirdId(id) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExpand/getCouponByThirdId?id=' + id,
      method: 'get'
    });
  },
  // xyCouponExchangeDetail/exportList 优惠券导出
  exportCouponData: function exportCouponData(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeDetail/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  exportCodeData: function exportCodeData(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeCode/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  exportProductList: function exportProductList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponProduct/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  }
};